<script setup lang="ts">
import { computed } from "vue";
import { responsiveVariables } from "../../utilities/helpers";
import type { IWrapperProps } from "./VWrapper.types";

const props = withDefaults(defineProps<IWrapperProps>(), {
  tag: "div",
});

const rootVariables = computed(() => {
  return {
    ...responsiveVariables("--_p", props.indent),
    ...responsiveVariables("--_p-ws", props.min),
    ...responsiveVariables("--_p-we", props.max),
  };
});
</script>

<template>
  <component :is="tag" class="pl-wrapper" :style="rootVariables">
    <slot />
  </component>
</template>

<style lang="postcss" scoped>
.pl-wrapper {
  --_p: 0;
  --_p-s: var(--_p);
  --_p-m: var(--_p-s);
  --_p-ml: var(--_p-m);
  --_p-l: var(--_p-ml);
  --_p-xl: var(--_p-l);
  --_p-ws: 320px;
  --_p-we: 1280px;
  --pl-wrapper-start: var(--_p-ws);
  --pl-wrapper-end: var(--_p-we);
  --pl-wrapper-indent: var(--_p);

  margin: 0 auto;
  padding: 0 var(--pl-wrapper-indent);
  min-width: var(--pl-wrapper-start);
  max-width: var(--pl-wrapper-end);
}

@media (--pl-viewport-from-s) {
  .pl-wrapper {
    --pl-wrapper-indent: var(--_p-s);
  }
}

@media (--pl-viewport-from-m) {
  .pl-wrapper {
    --pl-wrapper-indent: var(--_p-m);
  }
}

@media (--pl-viewport-from-ml) {
  .pl-wrapper {
    --pl-wrapper-indent: var(--_p-ml);
  }
}

@media (--pl-viewport-from-l) {
  .pl-wrapper {
    --pl-wrapper-indent: var(--_p-l);
  }
}

@media (--pl-viewport-from-xl) {
  .pl-wrapper {
    --pl-wrapper-indent: var(--_p-xl);
  }
}
</style>
